import { Component } from '@angular/core';

import { pedidoConfirmado } from '../../pedido-status';

@Component({
    selector: 'sgt-pedido-status-badge-confirmado',
    templateUrl: './pedido-status-badge-confirmado.component.html',
    styleUrls: ['./pedido-status-badge-confirmado.component.less']
})
export class PedidoStatusBadgeConfirmadoComponent {
    status = pedidoConfirmado;
}
